import { Component, Input, OnInit } from '@angular/core';
import { PopoverController} from '@ionic/angular';

@Component({
  selector: 'app-menu-custom',
  templateUrl: './menu-custom.component.html',
  styleUrls: ['./menu-custom.component.scss'],
})
export class MenuCustomComponent implements OnInit {
  @Input() menu = [];
  constructor(
    private popoverController: PopoverController,
  ) {
  
}

  ngOnInit() { }
  async setOption(key){
    await this.popoverController.dismiss(key);
  }

}
